import { CareTeamStatus, SearchOptions } from "../types/teams";

export const CARE_TEAMS_TAB = "care-teams";
export const SEARCH_BAR_WIDTH = 650;
export const TABLE_MIN_WIDTH = 830;
export const VALID_SEARCH_PARAMS_FILTERS = ["status"];

export const SEARCH_OPTIONS = [
  { label: "Client", value: SearchOptions.Client },
  { label: "Provider", value: SearchOptions.Provider },
];

export const SEARCH_PLACEHOLDERS = {
  [SearchOptions.Client]: "Search by client",
  [SearchOptions.Provider]: "Search by provider",
};

export const SEARCH_RESOURCES: Record<
  keyof typeof SEARCH_PLACEHOLDERS,
  "Patient" | "Practitioner"
> = {
  [SearchOptions.Client]: "Patient",
  [SearchOptions.Provider]: "Practitioner",
};

export const STATUS_FILTER_OPTIONS = [
  { label: "Active", value: CareTeamStatus.Active },
  { label: "Inactive", value: CareTeamStatus.Inactive },
];
